module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/lookup-management/post/post.component.css
// module id = ./src/app/admin/lookup-management/post/post.component.css
// module chunks = main